import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { goToOrganizationUpgrade } from 'data/ui/actions'
import { IncentiveBoxLayout, IncentiveBoxLayoutProps } from './Layout'
import { isFree } from 'data/organizations/selectors'

type IncentiveBoxProps = Omit<
  IncentiveBoxLayoutProps,
  'goToOrganizationUpgrade' | 'isOrganizationFree'
>

export default function IncentiveBox(props: IncentiveBoxProps) {
  const dispatch = useDispatch()
  const isOrganizationFree = useSelector(isFree)
  const _goToOrganizationUpgrade = React.useCallback(
    ({ incentiveId }) => {
      dispatch(goToOrganizationUpgrade({ incentiveId }))
    },
    [dispatch]
  )

  return (
    <IncentiveBoxLayout
      {...props}
      goToOrganizationUpgrade={_goToOrganizationUpgrade}
      isOrganizationFree={isOrganizationFree}
    />
  )
}
